// extracted by mini-css-extract-plugin
module.exports = {"popup":"_13B8aQ6GigD8ryA3G5niHU","closeButton":"_3FvurtrikEzQV0gBBWPY8O"};